module.exports = __webpack_public_path__ + "static/media/Ristolina_developer.bcb0162e.png";